import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { msalConfig } from "./auth/msal";
import "./styles/tailwind.css";

const MODE = import.meta.env.VITE_BACKEND ?? "mock";

async function bootstrap() {
  const root = ReactDOM.createRoot(document.getElementById("root")!);

  // Mock/PowerSDK: no MSAL needed — render directly.
  if (MODE !== "dataverse") {
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </React.StrictMode>,
    );
    return;
  }

  // Dataverse: initialise MSAL, handle the redirect response, then render.
  const msal = new PublicClientApplication(msalConfig);
  await msal.initialize();

  const response = await msal.handleRedirectPromise();
  if (response?.account) {
    msal.setActiveAccount(response.account);
  } else {
    const cached = msal.getAllAccounts()[0];
    if (cached) msal.setActiveAccount(cached);
  }

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msal}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>,
  );
}

bootstrap().catch((e) => {
  console.error("Bootstrap failed:", e);
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML = `<pre style="padding:24px;font-family:system-ui;color:#b91c1c;white-space:pre-wrap;">Bootstrap failed:\n${String(e)}</pre>`;
  }
});
